module.exports = __webpack_public_path__ + "static/unlimited-a8678b10431a18939a153ba217753b87.svg";